import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import getTranslation from '../../../../strings/i18n';
import { faDollarSign } from '@fortawesome/pro-regular-svg-icons';
import isNil from 'lodash-es/isNil';
import { useEffect } from 'react';
import { useMerchantInfoQuery } from 'syf-api/merchantInfo';
import { RenderIf } from 'syf-component-library/ui/atoms';
import SlideInModalLoader from 'syf-component-library/ui/atoms/Loader/Skeleton/SlideInModalLoader';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { useActivityContext } from '../../../../context/activity-store';
import { isCanceledPaymentTransaction, isNoErrorPurchaseOrCanceledPayment, isNotCanceledTransaction } from '../../../../helpers';
import { previouslyVisited } from '../../../../helpers/utils/activity-utils';
import { validateAmount } from '../../../../helpers/utils/amount-utils';
import TransactionDetail from '../../../common/transaction-detail';
import CanceledPaymentTransactionDetails from '../../cancel-payment/transaction-detail';
import Enrichment from '../../enrichment';
import NotCancelTransactionDetails from '../../not-cancel-transaction';
import { StyledDisputesContainer } from './subcomponents';
var ExtraInfoDetails = function (_a) {
    var config = _a.config, currentTransaction = _a.currentTransaction, type = _a.type;
    var status = currentTransaction.status, description = currentTransaction.description;
    var merchantId = description ? description.replaceAll(' ', '') : '';
    var emptyDescription = isNil(merchantId);
    var displayedTransactionAmount = validateAmount(currentTransaction.amount);
    var t = getTranslation().t;
    var triggerAnalyticsEvent = useActivityContext().triggerAnalyticsEvent;
    var enableMerchantInfoQuery = type === 'PURCHASE' && !emptyDescription;
    var _b = useMerchantInfoQuery({
        config: config,
        keyProps: {
            merchantId: merchantId
        },
        queryOptions: {
            enabled: enableMerchantInfoQuery,
            retry: false
        }
    }), merchantInfo = _b.data, isError = _b.isError, isFetching = _b.isFetching;
    useEffect(function () {
        triggerAnalyticsEvent({
            pageKind: 'activity',
            pageFunction: 'transaction_enrichment',
            pageSubFunction: 'popup',
            message: "".concat(type),
            pageName: 'view',
            previouslyVisited: "".concat(previouslyVisited)
        });
    }, [type, triggerAnalyticsEvent]);
    if (!Object.keys(currentTransaction).length)
        return _jsx("div", { children: "No transaction data" });
    if (isFetching) {
        return (_jsx(Inset, { all: "large", children: _jsx(SlideInModalLoader, {}) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(StyledDisputesContainer, { id: "eligibility-container-id" }), _jsxs("dl", { children: [_jsx(TransactionDetail, { title: "amountLabel", icon: faDollarSign, heading: t('activityDetails.amountLabel'), detail: displayedTransactionAmount }), _jsx(RenderIf, { condition: isNotCanceledTransaction(status), children: _jsx(NotCancelTransactionDetails, { emptyDescription: true, unsuccessfulEnrichmentRequest: isError, currentTransaction: currentTransaction, type: type }) }), _jsx(RenderIf, { condition: isCanceledPaymentTransaction(status, type), children: _jsx(CanceledPaymentTransactionDetails, { currentTransaction: currentTransaction, type: type }) })] }), _jsx(RenderIf, { condition: isNoErrorPurchaseOrCanceledPayment({
                    status: status,
                    type: type,
                    emptyDescription: emptyDescription,
                    isError: isError
                }), children: _jsx(Enrichment, { merchantInfo: merchantInfo, currentTransaction: currentTransaction, type: currentTransaction.type }) })] }));
};
export default ExtraInfoDetails;
//# sourceMappingURL=index.js.map